<sidenav-content>
    <app-avatar-block [initials]="data.profile.initials">
        <span avatarTitle>{{ data.profile.name }}</span>
        <span avatarDescription>{{ data.profile.id > -1 ? data.profile.id : 'PMC Management' }}</span>
    </app-avatar-block>

    <app-header-menu-items (notificationsMenuItemClicked)="switchToNotifications()"></app-header-menu-items>
</sidenav-content>
